"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _key = require("../../constants/key.codes");

var _propTypes = require("prop-types");

var _chip = _interopRequireDefault(require("../Chip/chip"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _textInput = _interopRequireDefault(require("../TextInput/textInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TYPE_TEXT = 'text';
var TYPE_EMAIL = 'email';

var TagsInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TagsInput, _React$Component);

  function TagsInput(props) {
    var _this;

    _classCallCheck(this, TagsInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TagsInput).call(this, props));
    _this.state = {
      typingValue: '',
      isFocused: false
    };
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.getValue = _this.getValue.bind(_assertThisInitialized(_this));
    _this.onTypingValueChange = _this.onTypingValueChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TagsInput, [{
    key: "getValue",
    value: function getValue() {
      return this.props.value || this.props.defaultValue || [];
    }
  }, {
    key: "addItems",
    value: function addItems(values) {
      return [].concat(_toConsumableArray(this.getValue()), _toConsumableArray(values));
    }
  }, {
    key: "removeItem",
    value: function removeItem(index) {
      return this.getValue().filter(function (val, i) {
        return index !== i;
      });
    }
  }, {
    key: "removeLastItem",
    value: function removeLastItem() {
      return this.getValue().slice(0, -1);
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var value = this.getValue();
      if (value.length > 0) this.addItems(value);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var newItems = nextProps.value || nextProps.defaultValue || [];

      if (newItems.length === this.getValue().length + 1) {
        this.setState({
          typingValue: ''
        });
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.textInput.focus();
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      this.setState({
        isFocused: false
      });
      this.props.onBlur({
        target: _objectSpread({}, event.target, {
          value: this.getValue()
        })
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      this.setState({
        isFocused: true
      });
      this.props.onFocus({
        target: _objectSpread({}, event.target, {
          value: this.getValue()
        })
      });
    }
  }, {
    key: "onTypingValueChange",
    value: function onTypingValueChange(event) {
      this.setState({
        typingValue: event.target.value
      });
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var value = event.target.value;
      this.props.onKeyDown(event);

      if (event.key === _key.COMMA_KEY) {
        event.preventDefault();
      }

      switch (event.key) {
        case _key.COMMA_KEY:
        case _key.ENTER_KEY:
          if (!value) return;
          this.props.onChange({
            target: {
              value: this.addItems([value])
            }
          });
          break;

        case _key.BACKSPACE_KEY:
          if (value) return;
          this.props.onChange({
            target: {
              value: this.removeLastItem()
            }
          });
          break;

        default:
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? TYPE_TEXT : _this$props$type,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          required = _this$props.required,
          tabIndex = _this$props.tabIndex,
          small = _this$props.small,
          large = _this$props.large;
      var items = this.getValue();
      return _react.default.createElement(_styler.default, {
        classNames: 'co-tags-input',
        modifiers: _objectSpread({}, this.props, {
          focused: this.state.isFocused
        })
      }, function (styles) {
        return _react.default.createElement("div", {
          className: styles,
          onClick: _this2.onClick
        }, items.map(function (item, index) {
          return _react.default.createElement(_chip.default, {
            truncated: true,
            small: !large,
            large: large,
            key: "".concat(item, "-").concat(index),
            onDismiss: function onDismiss() {
              return _this2.props.onChange({
                target: {
                  value: _this2.removeItem(index)
                }
              });
            }
          }, item);
        }), _react.default.createElement(_textInput.default, {
          id: id,
          name: name,
          type: type,
          ref: function ref(el) {
            _this2.textInput = el;
          },
          disabled: disabled,
          placeholder: placeholder,
          required: required,
          onBlur: _this2.onBlur,
          onFocus: _this2.onFocus,
          onKeyDown: _this2.onKeyDown,
          onKeyUp: _this2.props.onKeyUp,
          onChange: _this2.onTypingValueChange,
          value: _this2.state.typingValue,
          tabIndex: tabIndex,
          small: small,
          large: large
        }));
      });
    }
  }]);

  return TagsInput;
}(_react.default.Component);

var noop = function noop() {};

TagsInput.defaultProps = {
  onBlur: noop,
  onChange: noop,
  onFocus: noop,
  onKeyDown: noop
};
TagsInput.propTypes = _objectSpread({}, _textInput.default.propTypes, {
  defaultValue: _propTypes.array,
  name: _propTypes.string,
  value: _propTypes.array,
  type: (0, _propTypes.oneOf)([TYPE_TEXT, TYPE_EMAIL]),
  tabIndex: _propTypes.string
});
TagsInput.TYPE_TEXT = TYPE_TEXT;
TagsInput.TYPE_EMAIL = TYPE_EMAIL;
var _default = TagsInput;
exports.default = _default;
TagsInput.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getValue",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "addItems",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "values",
      "type": null
    }],
    "returns": null
  }, {
    "name": "removeItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "removeLastItem",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onClick",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onFocus",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onTypingValueChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onKeyDown",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "TagsInput",
  "props": {
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onFocus": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onKeyDown": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "defaultValue": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'text'",
          "computed": false
        }, {
          "value": "'email'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  },
  "composes": ["../TextInput/textInput"]
};